export default [
	{
		start: 0.05,
		end: 3,
		text: 'Après tout, c\'est peut-être de votre faute.'
	}
]
